import objectPath from 'object-path';

export default function hyperdbHandlers({ namespace }) {
  return {
    __INIT() {
      return {
        objects: {},
        page: 1,
        totalPages: 1,
        totalObjects: 0,
        searchKeyword: '',
        sort: null,
        selectedFilter: null,
        advancedFilters: null,
        useAdvancedFilters: false,
        deleteSuccessful: false,
        formLoaded: false,
        formChanged: false,
        showUnsavedObjectModal: false,
        objectMetadata: null,
        objectModel: null,
        objectData: null,
        submitSuccessful: false,
        savedObject: null,
        loading: false,
        errorMessage: null,
        successMessage: null,
      };
    },
    [`${namespace}__ERROR`]: (state, { payload }) => {
      const errorMessage = parseError(payload);
      return { ...state, loading: false, errorMessage };
    },
    [`${namespace}__FETCH_LISTING`]: (state, { payload }) => {
      const { searchKeyword, selectedFilter, useAdvancedFilters, advancedFilters, page, sort } = payload;
      return { ...state, loading: true, errorMessage: null, deleteSuccessful: false, searchKeyword: searchKeyword || '', selectedFilter, useAdvancedFilters, advancedFilters, page, sort };
    },
    [`${namespace}__LISTING_FETCHED`]: (state, { payload }) => {
      const { objects, totalPages, totalObjects } = payload;
      return { ...state, loading: false, objects, totalPages, totalObjects, errorMessage: null };
    },
    [`${namespace}__LEAVE_LISTING`]: (state) => {
      const listingParams = {
        page: 1,
        searchKeyword: '',
        sort: null,
        selectedFilter: null,
        advancedFilters: null,
        useAdvancedFilters: false,
      };
      return { ...state, ...listingParams, loading: false, errorMessage: null, successMessage: null, deleteSuccessful: false, submitSuccessful: false, postDataSuccessful: null };
    },
    [`${namespace}__OBJECTS_GOT`]: (state, { payload }) => {
      const { objects, propName } = payload;
      return { ...state, [propName]: objects, errorMessage: null, loading: false };
    },
    [`${namespace}__INIT_FORM`]: (state) => {
      return { ...state, formLoaded: false, submitSuccessful: false, objectMetadata: null, objectData: null, objectModel: null, errorMessage: null };
    },
    [`${namespace}__FORM_INITIALIZED`]: (state, { payload }) => {
      const { object, model } = payload;
      const { db_attr, ...data } = object || {};
      return { ...state, formChanged: false, formLoaded: true, objectMetadata: db_attr, objectData: data, objectModel: model, errorMessage: null };
    },
    [`${namespace}__SUBMIT_FORM`]: (state) => {
      return { ...state, loading: true, errorMessage: null, submitSuccessful: false };
    },
    [`${namespace}__SUBMIT_FORM_SUCCESS`]: (state, { payload }) => {
      const { savedObject, successMessage } = payload;
      return { ...state, formChanged: false, loading: false, errorMessage: null, savedObject, submitSuccessful: true, successMessage: successMessage || 'Object saved' };
    },
    [`${namespace}__UPDATE_OBJECT_DATA`]: (state, { payload }) => {
      const { attributeName, value, data, noSetDirty } = payload;
      const formChanged = noSetDirty ? state.formChanged : true;
      // whole object
      if (data) { return { ...state, objectData: data, formChanged }; }
      // Or update only attribute
      const objectData = { ...state.objectData };
      objectPath.set(objectData, attributeName, value); // attributeName can be path to embeddedObject
      return { ...state, objectData, formChanged };
    },
    [`${namespace}__SET_DATA`]: (state, { payload }) => {
      const data = payload;
      const loading = data.hasOwnProperty('loading') ? data.loading : false;
      return { ...state, ...data, loading };
    },
    [`${namespace}__GET_DATA`]: (state) => {
      return { ...state, loading: true, errorMessage: null };
    },
    [`${namespace}__GET_DATA_SUCCESS`]: (state) => {
      return { ...state, loading: false, errorMessage: null };
    },
    [`${namespace}__POST_DATA`]: (state) => {
      return { ...state, loading: true, postDataSuccessful: false, errorMessage: null };
    },
    [`${namespace}__POST_DATA_SUCCESS`]: (state, { payload }) => {
      return { ...state, loading: false, postDataSuccessful: true, errorMessage: null };
    },
    [`${namespace}__LEAVE_FORM`]: (state) => {
      return { ...state, formChanged: false, formLoaded: false, submitSuccessful: false, showUnsavedObjectModal: false, objectMetadata: null, objectData: null, objectModel: null, savedObject: null, postDataSuccessful: null };
    },
    [`${namespace}__GET_OBJECT`]: (state) => {
      return { ...state, loading: true, errorMessage: null, objectFecthed: false };
    },
    [`${namespace}__OBJECT_GOT`]: (state, { payload }) => {
      const object = payload || {};
      const { db_attr, ...data } = object;
      return { ...state, loading: false, objectFecthed: true, errorMessage: null, objectData: data, objectMetadata: db_attr };
    },
    [`${namespace}__DELETE_OBJECT`]: (state) => {
      return { ...state, loading: true, errorMessage: null, deleteSuccessful: false };
    },
    [`${namespace}__DELETE_OBJECT_SUCCESS`]: (state, { payload }) => {
      const successMessage = payload || 'Object deleted';
      return { ...state, loading: false, errorMessage: null, deleteSuccessful: true, successMessage };
    },
    [`${namespace}__DISMISS_ALERT`]: (state) => {
      return { ...state, errorMessage: null, successMessage: null };
    },
  };
}

function getUpdatedAdvancedFilters(advancedFilters, state) {
  const updatedAdvancedFilters = { ...state.advancedFilters };
  Object.keys(advancedFilters).forEach(filterName => {
    const value = advancedFilters[filterName];
    updatedAdvancedFilters[filterName].value = value;
  });
  return updatedAdvancedFilters;
}

function parseError(error) {
  return error && typeof error === 'object'
    ? error.message
    : error;
}



// WEBPACK FOOTER //
// ../hyperdb-utils/src/handlers.js